
<template>
  <div id="googlemapsholder" class="disable-all googlemapsapp">
    <transition name="slide-fade">
      <div class="row">
        <filtercollection
          v-bind:class="showfilters()"
          v-bind:title="$store.state.translation[90]"
          v-on:showfiltercol="showfiltercol"
          id="mapsfilter"
        >
          <Xfilter filtertitle="Specialisme(n)">
            <Xdropdownfilter name="specfilter" v-bind:options="allspecs"></Xdropdownfilter>
          </Xfilter>
          <Xfilter filtertitle="Praktijk">
            <Xtextboxfilter name="Praktijkfilter" v-bind:placeholder="$store.state.translation[14124]"></Xtextboxfilter>
          </Xfilter>
        </filtercollection>
      </div>
    </transition>
    <div class="row">
      <div class="col-lg-offset-3 col-lg-9">
        <div id="canvas-map" v-bind:class="{ blurback: showfysioview }"></div>
        <div class="container totop" v-if="!showparktijkview && !showfiltercollection">
          <div class="col-lg-offset-2 col-lg-5 col-md-offset-2 col-md-8 margin20">
            <div class="form-group">
              <div class="input-group" role="group" aria-label="search">
                <span class="input-group-btn">
                  <button type="button" class="btn btn-default"><i class="fa fa-search" aria-hidden="true"></i></button>
                </span>
                <input
                  type="search"
                  v-bind="valuesearchpraktijk"
                  v-on:change="inputsearchpraktijk"
                  v-on:keyup.13.prevent="inputsearchpraktijk"
                  v-bind:placeholder="$store.state.translation[14161]"
                  class="form-control"
                  id="email"
                />
              </div>
            </div>
            <div class="form-group">
              <span class="btn-block btn btn-primary hidden-lg" v-on:click="showfiltercollection = true">{{
                $store.state.translation[14123]
              }}</span>
            </div>
          </div>
        </div>
        <transition name="slide-fade">
          <googlemapsinterface
            id="mapsinterface"
            class="container"
            v-bind:markerdata="clickedmarkerdata"
            v-bind:showfiltercollection="showfiltercollection"
            v-on:showfysio="showfysio"
            v-bind:showparktijkview="showparktijkview"
            v-bind:showfysioview="showfysioview"
          ></googlemapsinterface>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
// import fam from 'fontawesome-markers'
import { util } from 'pevueglobal'
import axios from 'axios'

export default {
  data() {
    return {
      fontawesomemarkers: {},
      showfysioview: false,
      showparktijkview: false,
      showfiltercollection: false,
      clusterClicked: false,
      markerindex: 0,
      infoboxes: [],
      icons: [],
      googlemapsOptions: {
        // map settings
        zoom: 8,
        center: new google.maps.LatLng(51.96593143, 6.27978556),
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        gestureHandling: 'greedy',
        zoomControl: false,
        mapTypeControl: false,
        fullscreenControl: false,
      },
      map: {},
      card: '',
      markerdata: [],
      markers: [],
      markercluster: undefined,
      clickedmarkerdata: [],
      valuesearchpraktijk: '',
      allspecs: [],
      mapfilters: {
        praktijknaam: '',
        specialisme: '',
      },
      settrans: true,
    }
  },
  name: 'googlemaps',
  created() {
    // showwaitmodal()

    this.$store.dispatch('gettranslations', [90, 8944, 14124, 14161, 14123, 2030, 14133, 14162, 13741, 14164])

    axios
      .post(`SKF_Praktijken_Register.aspx/GetmapsData`, {
        headers: { 'Content-Type': 'application/json; charset=utf-8; multipart/form-data;' },
      })
      .then((response) => {
        // JSON responses are automatically parsed.
        this.markerdata = JSON.parse(response.data.d)
        this.initGooglemaps()
        // hidewaitmodal()
      })
  },
  methods: {
    showfilters: function () {
      if (this.showfiltercollection === false) {
        return 'hidden-xs hidden-sm hidden-md col-lg-3'
      } else {
        return 'col-md-3'
      }
    },
    inputsearchpraktijk: function (e) {
      var zoekterm = e.target.value
      e.target.value = ''
      var url =
        'https://maps.googleapis.com/maps/api/geocode/json?address=' +
        escape(zoekterm) +
        '&sensor=false&key=AIzaSyAfJ9ex4kKBM4pBAqKe904eOmtxrNvQlsM'
      axios.get(url, { withCredentials: false }).then((response) => {
        // JSON responses are automatically parsed.
        var location = response.data.results[0].geometry.location
        this.map.setZoom(12)
        this.map.setCenter(location)
      })
    },
    showfiltercol: function () {
      if (this.markercluster) {
        this.markercluster.clearMarkers()
      }
      this.showfiltercollection = false
      this.showparktijkview = false
      this.showfysioview = false
      var filterSpec = this.$store.getters.getFilter('specfilter')
      var filterNaam = this.$store.getters.getFilter('Praktijkfilter')

      this.markers.filter(function (o) {
        if (filterNaam === undefined && filterSpec === undefined) {
          o.setVisible(true)
          return
        }
        if (
          filterNaam !== undefined &&
          o.markerInfo.tblSKFVestigingNaam.toUpperCase().indexOf(filterNaam.value.toUpperCase()) !== -1
        ) {
          o.setVisible(true)
          return
        }

        if (filterSpec !== undefined && o.markerInfo.tblSpecs.some((specs) => specs.specid === filterSpec.value)) {
          o.setVisible(true)
          return
        }
        o.setVisible(false)
      })
      this.markercluster.repaint()
    },
    showfysio: function () {
      this.showfysioview = !this.showfysioview
    },
    initGooglemaps: function () {
      // fontawesomemarkers = JSON.parse(this.responseText)

      this.map = new google.maps.Map(document.getElementById('canvas-map'), this.googlemapsOptions)

      // put this component into local var, googlemaps does not respect es6 arrow functions :-(
      var vueElement = this
      this.markercluster = new MarkerClusterer(this.map, [], {
        imagePath: '/images/googlemaps/m',
        zoomOnClick: false,
        minimumClusterSize: 5,
        styles: [
          {
            url: '/images/googlemaps/marker.png',
            height: 55,
            width: 44,
            anchor: [55, 0],
            textColor: '#ffffff',
            textSize: 10,
          },
        ],
      })

      google.maps.event.addListener(this.markercluster, 'clusterclick', function (cluster) {
        vueElement.clusterClicked = true
        var ff = []
        cluster.markers_.forEach(function (marker) {
          ff.push(marker.markerInfo.tblSKFVestigingID)
        })
        vueElement.clickedmarkerdata = ff
        vueElement.showparktijkview = true
      })

      this.map.addListener('click', (ev) => {
        setTimeout(function () {
          if (!vueElement.clusterClicked) {
            if (vueElement.showfysioview === true) {
              vueElement.showfysioview = false
            } else {
              vueElement.showparktijkview = false
            }
          } else {
            vueElement.showparktijkview = true
          }
          vueElement.clusterClicked = false
        }, 0)
      })

      for (let markerInfo of this.markerdata) {
        var mysmarkerinfo = {
          position: new google.maps.LatLng(
            markerInfo.tblSKFVestigingCoordinateRetrievedLat,
            markerInfo.tblSKFVestigingCoordinateRetrievedLong
          ),
          map: this.map,
          // icon: {
          //     path: fam.MAP_MARKER,
          //     scale: 0.5,
          //     strokeWeight: 0.2,
          //     strokeColor: 'black',
          //     strokeOpacity: 1,
          //     fillColor: '#b04fc0',
          //     fillOpacity: 1
          // }
        }

        // offset position of marker when it is close to each other
        for (var i = 0; i < this.markers.length; i++) {
          var pos = this.markers[i].getPosition()

          if (util.getDistance(mysmarkerinfo.position, this.markers[i].getPosition()) < 50) {
            var a = 360.0 / this.markers.length
            var newLat = pos.lat() + -0.0004 * Math.cos(((+a * i) / 180) * Math.PI) // x
            var newLng = pos.lng() + -0.0004 * Math.sin(((+a * i) / 180) * Math.PI) // Y
            mysmarkerinfo.position = new google.maps.LatLng(newLat, newLng)
          }
        }

        var marker = new google.maps.Marker(mysmarkerinfo, true)

        marker.markerInfo = markerInfo
        marker.addListener('click', (marker) => {
          vueElement.clickedmarkerdata = []
          vueElement.showparktijkview = true
          vueElement.clickedmarkerdata.push(markerInfo.tblSKFVestigingID)
        })

        marker.addListener('visible_changed', function () {
          if (this.getVisible()) {
            vueElement.markercluster.addMarker(this)
          } else {
            vueElement.markercluster.removeMarker(this)
          }
        })

        marker.markerInfo.tblSpecs.forEach((spec) => {
          if (this.allspecs.some((specs) => specs.value === spec.specid) === false) {
            var newspec = { value: spec.specid, text: spec.specnaam }
            this.allspecs.push(newspec)
          }
        })
        marker.setVisible(true)
        this.markers.push(marker)
      }
    },
  },
}
</script>
